module.exports = __webpack_public_path__ + "media/cover.a00aa99e.mp4";